<template>
  <div class="evaluation-container max-w-4xl mx-auto p-4 ">
    <h2 class="text-2xl font-bold mb-6">{{ traslateType(evaluation.type) }}</h2>
    <hr />
    <div
      v-for="competency in evaluation.competencies"
      :key="competency.id"
      class="competency-section mb-4"
    >
      <h3 class="text-xl font-semibold text-blue-700">{{ competency.name }}</h3>
      <div
        v-for="question in competency.questions"
        :key="question.id"
        class="question-section mt-3"
      >
        <p class="text-lg text-gray-800">¿ {{ question.question_text }} ?</p>
        <div class="response-options mt-2">
          <div
            v-for="option in evaluation.response_options"
            :key="option.id"
            class="option flex items-center mb-2"
          >
            <input
              type="radio"
              :id="'question-' + question.id + '-option-' + option.id"
              :name="'question-' + question.id"
              :value="option.id"
              v-model="responses[question.id]"
              class="mr-2"
            />
            <label
              :for="'question-' + question.id + '-option-' + option.id"
              class="text-gray-700"
            >
              {{ option.description }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <button
      @click="submitEvaluation"
      class="mt-6 bg-blue-500 text-white px-4 py-2 rounded btn-success"
    >
      Enviar
    </button>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    evaluation: {
      type: Object, // Cambiado de Array a Object para reflejar correctamente los datos de evaluación
      required: true,
    },
  },
  data() {
    return {
      responses: {}, // Aquí se almacenan las respuestas
    };
  },
  methods: {
    traslateType(type) {
      let str = "";
      switch (type) {
        case "autoevaluation":
          str = "Autoevaluación";
          break;
        case "manager_evaluation":
          str = "Evaluación de Jefe";
          break;
        default:
          str = "Evaluación General";
          break;
      }
      return str;
    },
    async submitEvaluation() {
      const payload = {
        evaluation_id: this.evaluation.id, // ID de la evaluación
        responses: Object.entries(this.responses).map(([question_id, response_id]) => ({
          question_id: parseInt(question_id),
          response_id: response_id,
        })),
      };

      try {
        const response = await axios.post("/api/answers", payload);
        console.log("Respuesta enviada con éxito:", response.data);
        alert("Evaluación enviada exitosamente.");
      } catch (error) {
        console.error("Error al enviar la evaluación:", error.response || error);
        alert("Hubo un error al enviar la evaluación. Por favor, inténtelo de nuevo.");
      }
    },
  },
};
</script>

<style scoped>
.evaluation-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 16px;
  max-height: 95%;
}

.competency-section {
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 16px;
}

.question-section {
  margin-top: 16px;
}

.option {
  display: flex;
  align-items: center;
}

.option input[type="radio"] {
  margin-right: 8px;
}
</style>
